import React, { useState } from "react";
import SEOHelmet from '../SEOHelmet';
import { useNavigate } from 'react-router-dom';
import {
  FaLightbulb,
  FaChartBar,
  FaGlobe,
  FaLayerGroup,
  FaMicrochip,
  FaArrowRight,
  FaCheckCircle,
  FaStar,
  FaClock,
  FaUsers,
  FaFacebook,
  FaTwitter,
  FaLinkedin,
  FaInstagram
} from "react-icons/fa";
import ".././../styles/landing-page/FeaturesPage.css";
import Navbar from "./Navbar";
import FeaturePageImg from '../../assets/Featurepage.png';
import DashboardImg3 from '../../assets/Featurepageimg3.png';

import ctaimage1 from '../../assets/Mobileview.png';
import ctaimage2 from '../../assets/AdminDashboard2.png';
const features = [
  {
    icon: FaLightbulb,
    title: "Lightning Fast",
    desc: "Optimized performance that loads in milliseconds, keeping your users engaged.",
    highlight: true
  },
  {
    icon: FaLayerGroup,
    title: "Enterprise Security",
    desc: "Bank-grade encryption and security protocols protect your data 24/7."
  },
  {
    icon: FaChartBar,
    title: "Advanced Analytics",
    desc: "Real-time dashboards and insights to track every metric that matters."
  },
  {
    icon: FaGlobe,
    title: "Global Scale",
    desc: "Deploy across 50+ regions worldwide with automatic load balancing.",
    highlight: true
  },
  {
    icon: FaLayerGroup,
    title: "Seamless Integrations",
    desc: "Connect with 200+ tools and platforms your team already uses."
  },
  {
    icon: FaMicrochip,
    title: "AI-Powered",
    desc: "Built-in ML models that automate workflows and predict trends.",
    highlight: true
  }
];

const stats = [
  { value: "99.9%", label: "Uptime Guarantee", icon: FaArrowRight },
  { value: "<50ms", label: "Response Time", icon: FaClock },
  { value: "10M+", label: "Daily API Calls", icon: FaLightbulb },
  { value: "5,000+", label: "Active Teams", icon: FaUsers }
];

const SimpleButton = ({ children, className = "", onClick = () => {} }) => (
  <button className={`simple-btn ${className}`} onClick={onClick}>
    {children}
  </button>
);

const Features = () => {
  const navigate = useNavigate();
  const [activeSection, setActiveSection] = useState('features');
  return (
  <div className="features-page">
    <SEOHelmet page="features" canonicalUrl="https://www.assetflows.in/features" />
    <Navbar activeSection={activeSection} setActiveSection={setActiveSection} />
    {/* Hero Section */}
    <section className="features-hero">
      <div className="hero-content">
        <div className="hero-grid">
          <div className="hero-left">
            <span className="accent-badge">✨ What We Offer</span>
            <h1 className="hero-title">
              Features That <span className="highlight">Actually Matter</span>
            </h1>
            <p className="hero-description">
              Stop settling for tools that slow you down. Every feature is
              designed to help your team ship faster with confidence.
            </p>
            <div className="hero-buttons">
              <SimpleButton className="btn-primary">
                Explore All Features <FaArrowRight style={{ marginLeft: "8px" }} />
              </SimpleButton>
              <SimpleButton className="btn-ghost">
                See Pricing
              </SimpleButton>
            </div>
          </div>

          {/* Hero stats mini-cards */}
          <div className="hero-stats">
            {[
              { num: "200+", text: "Integrations" },
              { num: "50+", text: "Global Regions" },
              { num: "99.9%", text: "Uptime SLA" },
              { num: "24/7", text: "Expert Support" }
            ].map((card) => (
              <div key={card.text} className="stat-card">
                <div className="stat-number">{card.num}</div>
                <div className="stat-label">{card.text}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>

    {/* Feature Cards Grid */}
    <section className="features-section">
      <div className="section-container">
        <div className="section-header">
          
          <h2 className="section-title">Built for Performance</h2>
        </div>

        <div className="features-grid">
          {features.map((f) => {
            const Icon = f.icon;
            return (
              <div
                key={f.title}
                className={`feature-card ${f.highlight ? "highlight" : ""}`}
              >
                <div className="feature-icon">
                  <Icon size={22} />
                </div>
                <h3 className="feature-title">{f.title}</h3>
                <p className="feature-desc">{f.desc}</p>
                <div className="feature-link">
                  Learn more <FaArrowRight size={12} />
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>

    {/* Stats Band - left-aligned stats with right-side image */}
    <section className="stats-section">
      <div className="stats-wrapper">
        <div className="stats-content">
          <div className="stats-header-block">
            <h2 className="stats-main-title">Numbers That Speak</h2>
            <p className="stats-description">Trusted by teams who demand the best.</p>
          </div>
          <div className="stats-cards-container">
            {stats.map((s) => {
              const Icon = s.icon;
              return (
                <div key={s.label} className="stats-card-box">
                  <div className="stats-card-icon">
                    <Icon size={24} />
                  </div>
                  <div className="stats-card-value">{s.value}</div>
                  <div className="stats-card-label">{s.label}</div>
                </div>
              );
            })}
          </div>
        </div>

        {/* Right-side image placeholder: replace or populate with actual image */}
        <div className="stats-image-wrapper">
          <div className="stats-image-container">
            <img src={FeaturePageImg} alt="Maintenance Dashboard" className="stats-image-element" />
          </div>
        </div>
      </div>
    </section>

    {/* Why Us - Comparison with Zigzag Image Pattern */}
    <section className="comparison-section">
      <div className="comparison-container">
        <div className="comparison-header">
          <span className="accent-badge">Why Choose Us</span>
          <h2 className="comparison-title">The Difference Is Clear</h2>
        </div>
        
        {/* Zigzag Layout: Comparison Left, Image Right */}
        <div className="comparison-zigzag">
          <div className="comparison-content">
                
            <div className="comparison-box">
                 <div className="comparison-labels">
                <span>Features</span>
                <span className="label-us">Us</span>
                <span className="label-other">Others</span>
              </div>
              {[
                { feature: "Setup Time", us: "5 minutes", them: "2+ hours" },
                { feature: "Uptime SLA", us: "99.9%", them: "99.5%" },
                { feature: "Support Response", us: "< 1 hour", them: "24+ hours" },
                { feature: "Integrations", us: "200+", them: "50-80" },
                { feature: "AI Features", us: "Built-in", them: "Add-on ($)" }
              ].map((row) => (
                <div key={row.feature} className="comparison-row">
                  <span className="comparison-feature">{row.feature}</span>
                  <span className="comparison-us">
                    <FaCheckCircle size={14} /> {row.us}
                  </span>
                  <span className="comparison-other">{row.them}</span>
                </div>
              ))}
       
            </div>
          </div>
          
          <div className="comparison-image-wrapper">
            <div className="comparison-image-inner">
              <img src={DashboardImg3} alt="Comparison Dashboard" className="comparison-image" />
            </div>
          </div>
        </div>
      </div>
    </section>

    {/* Testimonial */}
    <section className="testimonial-section">
      <div className="testimonial-container">
        <div className="stars">
          {[...Array(5)].map((_, i) => (
            <FaStar key={i} size={20} className="star-icon" />
          ))}
        </div>
        <blockquote className="testimonial-quote">
          "This platform completely transformed how our team ships products. The
          speed and reliability are unmatched."
        </blockquote>
        <div className="testimonial-author">
          <p className="author-name">Sarah Chen</p>
          <p className="author-title">VP Engineering, TechCorp</p>
        </div>
      </div>
    </section>

    {/* Final CTA */}
    <section className="pricing-cta">
      <div className="pricing-cta-content">
        <div className="pricing-cta-left">
          <h2>Ready to Transform Your Asset Management?</h2>
          <p>
            Start your 14-day free trial today. No credit card required. Join thousands of organizations 
            trusting AssetFlows with their most critical assets.
          </p>
          <button>Start Your Free Trial</button>
        </div>
        <div className="pricing-cta-right">
          <div className="cta-mockup-container">
            <div className="cta-mockup-mobile">
              <img src={ctaimage1} alt="Mobile View" />
            </div>
            <div className="cta-mockup-laptop">
              <img src={ctaimage2} alt="Laptop View" />
            </div>
          </div>
        </div>
      </div>
    </section>

    {/* FOOTER SECTION */}
    <footer className="pricing-footer">
      <div className="footer-content">
        <div className="footer-grid">
          {/* Brand Section */}
          <div className="footer-section">
            <div className="footer-brand">
              <span>📦</span>
              <span>AssetFlows</span>
            </div>
            <p className="footer-description">
              The most comprehensive, user-friendly asset management platform trusted by 5,000+ organizations worldwide. 
              From startups to Fortune 500 companies, AssetFlows is the smart choice for intelligent asset management, 
              maintenance tracking, and operational excellence.
            </p>
            <div className="footer-social">
              <button onClick={() => {}} title="Facebook" className="icon-btn"><FaFacebook /></button>
              <button onClick={() => {}} title="Twitter" className="icon-btn"><FaTwitter /></button>
              <button onClick={() => {}} title="LinkedIn" className="icon-btn"><FaLinkedin /></button>
              <button onClick={() => {}} title="Instagram" className="icon-btn"><FaInstagram /></button>
            </div>
          </div>

          {/* Product Section */}
          <div className="footer-section">
            <h4>Product</h4>
            <ul>
              <li><a href="/pricing" onClick={() => navigate('/pricing')}>Pricing</a></li>
              <li><a href="/why-assetflow" onClick={() => navigate('/why-assetflow')}>Why AssetFlows</a></li>
              <li><span>Features</span></li>
              <li><span>Security</span></li>
              <li><span>Integrations</span></li>
            </ul>
          </div>

          {/* Company Section */}
          <div className="footer-section">
            <h4>Company</h4>
            <ul>
              <li><span>About Us</span></li>
              <li><span>Blog</span></li>
              <li><span>Careers</span></li>
              <li><span>Contact</span></li>
              <li><span>Partners</span></li>
            </ul>
          </div>

          {/* Resources Section */}
          <div className="footer-section">
            <h4>Resources</h4>
            <ul>
              <li><span>Documentation</span></li>
              <li><span>Support</span></li>
              <li><span>FAQ</span></li>
              <li><span>Community</span></li>
              <li><span>Status</span></li>
            </ul>
          </div>
        </div>

        {/* Divider */}
        <div className="footer-divider"></div>

        {/* Bottom Footer */}
        <div className="footer-bottom">
          <p>&copy; 2024 AssetFlows. All rights reserved.</p>
          <div className="footer-links">
            <button onClick={() => {}} className="footer-link-btn">Privacy Policy</button>
            <button onClick={() => {}} className="footer-link-btn">Terms of Service</button>
            <button onClick={() => {}} className="footer-link-btn">Cookie Policy</button>
            <button onClick={() => {}} className="footer-link-btn">Security</button>
          </div>
        </div>
      </div>
    </footer>
  </div>
);
}

export default Features;
